export default __webpack_public_path__ + "static/media/MyProfilePhoto.9e0fce5f.JPG";